import axios from 'axios'

export default {
  // Resolved header for a public page: { module } or the products page's
  // brand / sub_brand / department / category query. data is null when none.
  resolve (params) {
    return axios.get('/api/page-header', { params })
  },

  // Admin: stored config for a module ({ module }) or a node ({ brand_id, … }).
  show (target) {
    return axios.get('/api/admin/page-headers/show', { params: target })
  },

  // Admin: replace the whole header for that module or node.
  upsert (payload) {
    return axios.put('/api/admin/page-headers', payload)
  }
}
